import CoordenadorService from '../../services/CoordenadorService'

const state = {
    coordenadores: []
};

const mutations = {
    SET_COORDENADORES(state, coordenadores) {
        state.coordenadores = coordenadores;
    }
};

const actions = {
    async fetchPublicCoordenadores({ commit }) {
        try {
            const { data } = await CoordenadorService.get();
            commit('SET_COORDENADORES', data.itens);
        } catch (error) {
            console.error('Erro ao buscar coordenadores:', error);
        }
    }
};

const getters = {
    getCoordenadores: state => state.coordenadores
};

export default {
    state,
    mutations,
    actions,
    getters
};
